import React, { useState } from 'react';

function StepTwo({ formData, onNext }) {
    const [fullName, setFullName] = useState(formData.fullName || '');
    const [dob, setDob] = useState(formData.dob || '');
    const [jobTitle, setJobTitle] = useState(formData.jobTitle || '');
    const [startDate, setStartDate] = useState(formData.startDate || '');
    const [contactNumber, setContactNumber] = useState(formData.contactNumber || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!fullName || !dob || !jobTitle || !startDate || !contactNumber) {
            setError('Please fill out all required fields.');
            return;
        }

        setError('');
        onNext({
            fullName,
            dob,
            jobTitle,
            startDate,
            contactNumber,
        });
    };

    const isFormValid = fullName && dob && jobTitle && startDate && contactNumber;

    return (
        <div className="step-form">
            <h6 className="mb-4">Personal Information</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className="row">
                <div className="col-lg-6">
                    <div className="mb-3">
                        <label className="form-label">Full Name</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Full Name"
                            value={fullName}
                            onChange={e => setFullName(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-3">
                        <label className="form-label">Date of Birth <small className="text-muted">(DD/MM/YYYY)</small></label>
                        <input
                            type="date"
                            className="form-control"
                            value={dob}
                            onChange={e => setDob(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-3">
                        <label className="form-label">Job Title / Department</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Job Title / Department"
                            value={jobTitle}
                            onChange={e => setJobTitle(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-3">
                        <label className="form-label">Start Date <small className="text-muted">(DD/MM/YYYY)</small></label>
                        <input
                            type="date"
                            className="form-control"
                            value={startDate}
                            onChange={e => setStartDate(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="mb-3">
                        <label className="form-label">Contact Number</label>
                        <input
                            type="tel"
                            className="form-control"
                            placeholder="Contact Number"
                            value={contactNumber}
                            onChange={e => setContactNumber(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepTwo;
